import GradientBorderRadius from "@/ui/gradient-border-radius";
import TokenScreenerHeader from "./token-screener-header";
import { TokenScreenerTable } from "./token-screener-table";

const TokenScreenerPage = () => {
  return (
    <GradientBorderRadius overflow className="flex-1 flex w-full">
      <div className="flex-1 flex flex-col w-full gap-[0.625rem] pt-[0.625rem]">
        <TokenScreenerHeader />
        <TokenScreenerTable />
      </div>
    </GradientBorderRadius>
  );
};

export default TokenScreenerPage;
